const handleProductVar = (setProductVar, fabricId, productData, sizeId = null) => {
  setProductVar({
    fabric_id: fabricId,
    frame_id: productData.frame.id,
    ...(productData.frame.size !== null && {
      size_id: productData.frame.size.id
    }),
    size_id: sizeId,
    //render property / value if the leg is not null
    ...(productData.leg !== null && {
      leg_id: productData.leg.id
    }),
    ...(productData.frame.firmness && {
      firmness_id: productData.frame.firmness.id
    }),
    ...(productData.casterLeg && {
      caster_leg_id: productData.casterLeg.id
    }),
    ...(productData.constructionType && {
      construction_type_id: productData.constructionType.id
    }),
    ...(productData.lining && {
      lining_id: productData.lining.id
    }),
    ...(productData.frame.orientation !== null && {
      orientation: productData.frame.orientation
    }),
    ...(productData.frame.has_assembly_options && {
      is_assembled: productData.is_assembled
    }),
    ...(productData.frame.has_set_of_two && {
      supplier_quantity: productData.supplier_quantity
    }),
    ...(productData.frame.has_wallpaper_types && {
      wallpaper_type: productData.wallpaper_type
    }),

  });
};

export default handleProductVar;
